import config from "@/config";
import http from "@/utils/request";
import { get } from "sortablejs";

export default {
	flow: {
		list: {
			url: `${config.API_URL}/api/ly/flow/list`,
			name: "获取流程列表",
			get: async function (data = {}, config = {}) {
				return await http.get(this.url, data, config);
			},
		},
		update: {
			url: `${config.API_URL}/api/ly/flow/updateNode`,
			name: "更新流程节点",
			put: async function (data = {}) {
				return await http.put(this.url, data);
			},
		},
		approval: {
			url: `${config.API_URL}/api/ly/flow/approval`,
			name: "审批操作",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		revoke: {
			url: `${config.API_URL}/api/ly/flow/revoke`,
			name: "审核撤回",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		detail: {
			url: `${config.API_URL}/api/ly/flow/detail/`,
			name: "获取流程节点",
			get: async function (data = {}) {
				return await http.get(`${this.url}${data}`);
			},
		},
	},
	pay: {
		create: {
			url: `${config.API_URL}/api/ly/pay/approval/create`,
			name: "生成支付审核记录",
			post: async function (data = {}, config = {}) {
				return await http.post(this.url, data, config);
			},
		},
		update: {
			url: `${config.API_URL}/admin/order/updateOrderPayApproval`,
			name: "更新支付审核记录",
			post: async function (data = {}, config = {}) {
				return await http.post(this.url, data, config);
			},
		},
		delete: {
			url: `${config.API_URL}/ly/pay/approval/delete`,
			name: "删除支付审核记录",
			get: async function (id, config = {}) {
				return await http.get(`${this.url}/${id}`, {}, config);
			},
		},
		list: {
			url: `${config.API_URL}/api/ly/pay/approval/page`,
			name: "支付审核列表",
			get: async function (data = {}, config = {}) {
				return await http.get(this.url, data, config);
			},
		},
		detail: {
			url: `${config.API_URL}/api/ly/pay/approval/detail/`,
			name: "支付审核详情",
			get: async function (data = {}) {
				return await http.get(`${this.url}${data}`);
			},
		},
		export: {
			url: `${config.API_URL}/api/ly/pay/approval/export`,
			name: "支付审核导出",
			post: async function (data = {}, config = {}) {
				return await http.post(this.url, data, config);
			},
		},
	},
	sales: {
		create: {
			url: `${config.API_URL}/api/ly/sales/approval/create`,
			name: "生成售后审核记录",
			post: async function (data = {}, config = {}) {
				return await http.post(this.url, data, config);
			},
		},
		list: {
			url: `${config.API_URL}/api/ly/sales/approval/page`,
			name: "售后审核列表",
			get: async function (data = {}, config = {}) {
				return await http.get(this.url, data, config);
			},
		},
		detail: {
			url: `${config.API_URL}/api/ly/sales/approval/detail/`,
			name: "售后审核详情",
			get: async function (data = {}) {
				return await http.get(`${this.url}${data}`);
			},
		},
		bank: {
			url: `${config.API_URL}/api/ly/sales/approval/update/bank`,
			name: "修改收款账户",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		export: {
			url: `${config.API_URL}/admin/sale_approval/export`,
			name: "售后审核导出",
			post: async function (data = {}, config = {}) {
				return await http.post(this.url, data, config);
			},
		},
		payment: {
			url: `${config.API_URL}/api/ly/sales/approval/payment`,
			name: "立即打款",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		update: {
			url: `${config.API_URL}/api/ly/sales/approval/update`,
			name: "更新售后审核记录",
			post: async function (data = {}, config = {}) {
				return await http.post(this.url, data, config);
			},
		},
	},
	level: {
		create: {
			url: `${config.API_URL}/api/ly/level/change/approval/create`,
			name: "生成用户等级变更审核记录",
			post: async function (data = {}, config = {}) {
				return await http.post(this.url, data, config);
			},
		},
		list: {
			url: `${config.API_URL}/api/ly/level/change/approval/page`,
			name: "用户等级变更审核列表",
			get: async function (data = {}, config = {}) {
				return await http.get(this.url, data, config);
			},
		},
		detail: {
			url: `${config.API_URL}/api/ly/level/change/approval/detail`,
			name: "用户等级变更审核详情",
			get: async function (data = {}) {
				return await http.get(`${this.url}/${data}`);
			},
		},
		export: {
			url: `${config.API_URL}/api/ly/level/change/approval/export`,
			name: "用户等级变更审核导出",
			post: async function (data = {}, config = {}) {
				return await http.post(this.url, data, config);
			},
		},
	},
	referrer: {
		create: {
			url: `${config.API_URL}/api/ly/referrer/change/create`,
			name: "用户推荐人变更审核记录",
			post: async function (data = {}, config = {}) {
				return await http.post(this.url, data, config);
			},
		},
		list: {
			url: `${config.API_URL}/api/ly/referrer/change/page`,
			name: "用户推荐人变更审核列表",
			get: async function (data = {}, config = {}) {
				return await http.get(this.url, data, config);
			},
		},
		detail: {
			url: `${config.API_URL}/api/ly/referrer/change/detail/`,
			name: "用户推荐人变变更审核详情",
			get: async function (data = {}) {
				return await http.get(`${this.url}${data}`);
			},
		},
		export: {
			url: `${config.API_URL}/api/ly/referrer/change/export`,
			name: "售后审核导出",
			post: async function (data = {}, config = {}) {
				return await http.post(this.url, data, config);
			},
		},
	},
	approval: {
		list: {
			url: `${config.API_URL}/api/ly/contract/approval/page`,
			name: "签约审核列表",
			get: async function (data = {}, config = {}) {
				return await http.get(this.url, data, config);
			},
		},
		detail: {
			url: `${config.API_URL}/api/ly/contract/approval/detail`,
			name: "签约审核详情",
			get: async function (data = {}) {
				return await http.get(`${this.url}/${data}`);
			},
		},
		export: {
			url: `${config.API_URL}/api/ly/contract/approval/export`,
			name: "签约审核导出",
			post: async function (data = {}, config = {}) {
				return await http.post(this.url, data, config);
			},
		},
	},
	service: {
		create: {
			url: `${config.API_URL}/api/ly/service/change/create`,
			name: "服务对象变更审核记录",
			post: async function (data = {}, config = {}) {
				return await http.post(this.url, data, config);
			},
		},
		list: {
			url: `${config.API_URL}/api/ly/service/change/page`,
			name: "服务对象变更审核列表",
			get: async function (data = {}, config = {}) {
				return await http.get(this.url, data, config);
			},
		},
		detail: {
			url: `${config.API_URL}/api/ly/service/change/detail`,
			name: "服务对象详情",
			get: async function (data = {}) {
				return await http.get(`${this.url}/${data}`);
			},
		},
		export: {
			url: `${config.API_URL}/api/ly/service/change/export`,
			name: "服务对象审核导出",
			post: async function (data = {}, config = {}) {
				return await http.post(this.url, data, config);
			},
		},
	},
	transfer: {
		create: {
			url: `${config.API_URL}/api/ly/order/transfer/approval/create`,
			name: "生成订单转移审核记录",
			post: async function (data = {}, config = {}) {
				return await http.post(this.url, data, config);
			},
		},
		list: {
			url: `${config.API_URL}/api/ly/order/transfer/approval/page`,
			name: "订单转移审核列表",
			get: async function (data = {}, config = {}) {
				return await http.get(this.url, data, config);
			},
		},
		detail: {
			url: `${config.API_URL}/api/ly/order/transfer/approval/detail`,
			name: "订单转移变更审核详情",
			get: async function (data = {}) {
				return await http.get(`${this.url}/${data}`);
			},
		},
		export: {
			url: `${config.API_URL}/api/ly/order/transfer/approval/export`,
			name: "订单转移变更审核导出",
			post: async function (data = {}, config = {}) {
				return await http.post(this.url, data, config);
			},
		},
	},
};
